export enum PetProtectionScope {
	Booking = 1,
	AllBookings = 2,
}
